export default __webpack_public_path__ + "resources/icons/d100-c733.png";